/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SearchGranteeSalesRightsMutation from '../graphql/mutations/SearchGranteeSalesRightsMutation.js';

export const useSearchGranteeSalesRightsMutation = () => {
  return useCommitMutation(SearchGranteeSalesRightsMutation, {
    dataProp: 'searchGranteeSalesRights_M_simulation_pavillon_information'
  });
};

export default useSearchGranteeSalesRightsMutation;
